"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfigBits = exports.getTemplateSettings = exports.getTemplatePayload = exports.getTemplates = void 0;
var AutoModuleHelper = __importStar(require("./AutoModuleHelpers"));
var Arrays_1 = require("@microchip/scf-device/lib/util/Arrays");
var getConfigData_1 = require("./getConfigData");
var Utils_1 = require("../Utils");
var AutoModuleHardware_1 = require("./AutoModuleHardware");
var AutoModuleHelpers_1 = require("./AutoModuleHelpers");
var getTemplates = function (model) {
    var _a;
    var config = (0, getConfigData_1.getConfigData)(model);
    var templates = [];
    (_a = config === null || config === void 0 ? void 0 : config.templates) === null || _a === void 0 ? void 0 : _a.forEach(function (template) {
        var _a, _b, _c;
        var newTemplate = __assign({}, template);
        if (!model)
            return;
        newTemplate.dest =
            (_c = (_b = (_a = model.getDerivedFunctions()).templateName) === null || _b === void 0 ? void 0 : _b.call(_a, newTemplate.src)) !== null && _c !== void 0 ? _c : newTemplate.dest;
        newTemplate.dest = newTemplate.dest.replace("${sourceFileName}", model.getName().toLowerCase() + ".c");
        newTemplate.dest = newTemplate.dest.replace("${headerFileName}", model.getName().toLowerCase() + ".h");
        if (shouldGenerate(newTemplate, model)) {
            templates.push(newTemplate);
        }
    });
    return templates;
};
exports.getTemplates = getTemplates;
var shouldGenerate = function (template, model) {
    var shouldGenerate = true;
    if (!model)
        return shouldGenerate;
    if (shouldGenerate &&
        template.generateWithHardware == true &&
        !(0, AutoModuleHardware_1.isFullyAssigned)(model.getPrototypeModule().imports, (0, getConfigData_1.getConfigData)(model))) {
        shouldGenerate = false;
    }
    if (shouldGenerate &&
        template.isGeneratableProperty &&
        model.getDerivedFunction(template.isGeneratableProperty) != true) {
        shouldGenerate = false;
    }
    return shouldGenerate;
};
var getTemplatePayload = function (model) {
    var _a;
    if (!model)
        return undefined;
    var config = (0, getConfigData_1.getConfigData)(model);
    var moduleName = model.getName();
    var templatePayload = {
        name: {
            uppercase: moduleName.toUpperCase(),
            lowercase: moduleName.toLowerCase(),
            instance: moduleName,
        },
        filename: {
            source: "".concat(moduleName.toLowerCase(), ".c"),
            header: "".concat(moduleName.toLowerCase(), ".h"),
        },
    };
    var components = model
        .getAutoModuleAppModel()
        .getAllComponents();
    (_a = (0, Utils_1.values)(components)) === null || _a === void 0 ? void 0 : _a.forEach(function (entry) {
        templatePayload[entry.component.name] = getComponentPayload(entry.component, model);
    });
    templatePayload = __assign(__assign({}, templatePayload), (0, exports.getTemplateSettings)(model, config));
    return templatePayload;
};
exports.getTemplatePayload = getTemplatePayload;
var getTemplateSettings = function (model, config) {
    var _a, _b;
    if (!(model === null || model === void 0 ? void 0 : model.getHardware()))
        return undefined;
    return {
        registers: model.getRegisterValues(undefined),
        interrupts: (_a = model.getHardware()) === null || _a === void 0 ? void 0 : _a.getPeripheral().interrupts,
        properties: (_b = model.getHardware()) === null || _b === void 0 ? void 0 : _b.getPeripheral().properties,
    };
};
exports.getTemplateSettings = getTemplateSettings;
var getConfigBits = function (model) {
    var _a, _b, _c;
    var config = (0, getConfigData_1.getConfigData)(model);
    var configModule = (0, Arrays_1.find)((_a = config === null || config === void 0 ? void 0 : config.peripherals) !== null && _a !== void 0 ? _a : [], function (peripheral) {
        return AutoModuleHelper.hasConfigBits(peripheral.interfaceId.name);
    });
    if (configModule) {
        var interfaceName = AutoModuleHelper.getFriendlyInterfaceId(configModule.interfaceId.name);
        var templateConfigBits_1 = {};
        var registers_1 = (_b = model.getHardware(interfaceName)) === null || _b === void 0 ? void 0 : _b.getPeripheral().registers;
        (_c = (0, Utils_1.getKeys)(registers_1 !== null && registers_1 !== void 0 ? registers_1 : [])) === null || _c === void 0 ? void 0 : _c.forEach(function (configName) {
            var _a;
            var _b;
            var configBits = (_b = configModule.registers) === null || _b === void 0 ? void 0 : _b[configName];
            templateConfigBits_1 = __assign(__assign({}, templateConfigBits_1), (_a = {}, _a[configName] = {}, _a));
            configBits === null || configBits === void 0 ? void 0 : configBits.forEach(function (configBit) {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                var register = registers_1 === null || registers_1 === void 0 ? void 0 : registers_1[configName];
                var value;
                if (register && !register.settings) {
                    //missing settings for register
                    value = (_b = (_a = model.getComponent(configBit.name)) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "";
                }
                else {
                    var setting = (_d = (_c = registers_1 === null || registers_1 === void 0 ? void 0 : registers_1[configName]) === null || _c === void 0 ? void 0 : _c.settings) === null || _d === void 0 ? void 0 : _d[configBit.setting];
                    value =
                        (_g = (_f = (0, Arrays_1.find)((_e = setting === null || setting === void 0 ? void 0 : setting.options) !== null && _e !== void 0 ? _e : [], function (option) {
                            var _a, _b, _c;
                            return option.description ===
                                ((_a = model.getComponent(configBit.name)) === null || _a === void 0 ? void 0 : _a.value) ||
                                option.alias ===
                                    ((_b = model.getComponent(configBit.name)) === null || _b === void 0 ? void 0 : _b.value) ||
                                option.name === ((_c = model.getComponent(configBit.name)) === null || _c === void 0 ? void 0 : _c.value);
                        })) === null || _f === void 0 ? void 0 : _f.name) !== null && _g !== void 0 ? _g : "";
                }
                templateConfigBits_1[configName][configBit.setting] = {
                    name: configBit.setting,
                    value: value,
                    description: configBit.description,
                    valueAsDescription: (_h = model.getComponent(configBit.name)) === null || _h === void 0 ? void 0 : _h.value,
                };
            });
        });
        return templateConfigBits_1;
    }
    else {
        return {};
    }
};
exports.getConfigBits = getConfigBits;
var getComponentPayload = function (component, model) {
    var _a, _b;
    var componentValue = model.getComponentValue(component.name);
    switch (component.type) {
        case "ComboBox":
            if (component.category === "hardware") {
                var setting = AutoModuleHelper.getSettingFromComponent(model, component);
                return {
                    value: componentValue,
                    options: AutoModuleHelper.getSettingOptionsIfPresent(component, setting, model.getComponentValue((_b = (_a = component.mode) === null || _a === void 0 ? void 0 : _a.masterComponent) !== null && _b !== void 0 ? _b : "")),
                };
            }
            else if (component.category === "software") {
                return {
                    value: componentValue,
                    options: (0, AutoModuleHelpers_1.getComboOptions)(model.getDerivedFunctions().overrideOptions, component),
                };
            }
            break;
        case "boolean":
            return model.isComponentValue(component.name);
        case "number":
        case "string":
        case "register":
        default:
            return componentValue;
    }
};
//# sourceMappingURL=AutoModuleTemplates.js.map